import axios from "axios";
import { API_BASE as SBIN_API_BASE } from "./base";

const API = SBIN_API_BASE;

const authHeaders = (token) => {
  const authToken = token || null;
  return authToken ? { Authorization: `Bearer ${authToken}` } : {};
};

export async function getGoogleDriveStatus(token) {
  const res = await axios.get(`${API}/integrations/google-drive/status`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function createGoogleDriveAuthUrl(token) {
  const res = await axios.post(
    `${API}/integrations/google-drive/auth-url`,
    {},
    { headers: authHeaders(token) }
  );
  return res.data;
}

export async function setGoogleDriveEnabled(enabled, token) {
  const res = await axios.post(
    `${API}/integrations/google-drive/enable`,
    { enabled: Boolean(enabled) },
    { headers: authHeaders(token) }
  );
  return res.data;
}

export async function disconnectGoogleDrive(token) {
  const res = await axios.post(
    `${API}/integrations/google-drive/disconnect`,
    {},
    { headers: authHeaders(token) }
  );
  return res.data;
}

export async function testGoogleDriveUpload(token) {
  const res = await axios.post(
    `${API}/integrations/google-drive/test-upload`,
    {},
    { headers: authHeaders(token) }
  );
  return res.data;
}
